// Ported (slimmed) from V1's types/special-options.types.ts — the
// non-employee choices allowed in specific assignee columns. Values are
// stored in row_data as these exact strings.

const SPECIAL_OPTIONS_BY_COLUMN: Record<string, string[]> = {
  'Sales Taxes Assigned To': ['NA', 'No Sales Tax'],
  'Payroll Taxes Assigned To': ['NA', 'No Payroll'],
  'Account Manager': ['NA', 'No Bookkeeping'],
  Bookkeeper: ['NA', 'No Bookkeeping'],
  'QB Process': ['NA', 'No Bookkeeping'],
};

export function specialOptionsForColumn(columnName: string): string[] {
  return SPECIAL_OPTIONS_BY_COLUMN[columnName] ?? [];
}
